import { type BaseRequestOptions } from '../common'
import { GeneratedActivationApi } from '../generated/activations'
import { type ApiSchemaRequest, type ApiSchemaResponse, createSchemaApiRequest } from '../schema'

export class ActivationApi extends GeneratedActivationApi {
  async populate (config: ApiSchemaRequest<'/activations/populate', 'post', /** Activation[] */ unknown[]> & BaseRequestOptions): Promise<ApiSchemaResponse<'/activations/populate', 'post'>> {
    return await createSchemaApiRequest({
      path: '/activations/populate',
      method: 'post',
      ctx: this.ctx,
      data: config.data,
      options: config
    })
  }

  async applyAccessControls (config: ApiSchemaRequest<'/activations/access-controls/apply', 'post', { accessControlRules: unknown[], items: unknown[] }> & BaseRequestOptions): Promise<ApiSchemaResponse<'/activations/access-controls/apply', 'post'>> {
    return await createSchemaApiRequest({
      path: '/activations/access-controls/apply',
      method: 'post',
      ctx: this.ctx,
      data: config.data,
      options: config
    })
  }
}
